module.exports = __webpack_public_path__ + "static/media/sag_adjuster_plate.a71e7675.webp";